import React from 'react';
import { Preloader } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { createPortal } from 'react-dom';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import { EZIndices } from "../constants";
import { getPortalContainer } from "../../utils/window";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Loader = function Loader() {
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    "aria-label": "loader",
    "aria-modal": "true",
    className: cn('loader', cnComponentsTheme()),
    style: {
      zIndex: EZIndices.Overlay
    },
    "data-t-id": "components-Loader"
  }, /*#__PURE__*/React.createElement(Preloader, {
    color: "light",
    size: "m"
  })), getPortalContainer());
};